import * as React from 'react';
import { Switch, Route } from 'react-router';

import PATHS from '../../constants/paths';

import SignUpForm from './SignUpForm';
import SignInForm from './SignInForm';
import ResetPasswordForm from './ResetPasswordForm';

import CloudLabel from '../../components/CloudLabel';

import styled from 'styled-components';

const AuthContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;

const AuthContent = styled.div`
  max-width: 22.5rem;
  width: 100vw;
`;

const BottomPanel = styled.div`
  margin-top: 6rem;
`;

const Auth = () => {
  return (
    <AuthContainer>
      <AuthContent>
        <Switch>
          <Route path={PATHS.AUTH.SIGN_UP} component={SignUpForm} />
          <Route path={PATHS.AUTH.SIGN_IN} component={SignInForm} />
          <Route path={PATHS.AUTH.RESET_PASSWORD} component={ResetPasswordForm} />
        </Switch>

        <BottomPanel>
          <CloudLabel />
        </BottomPanel>
      </AuthContent>
    </AuthContainer>
  );
};

export default Auth;



// WEBPACK FOOTER //
// ./src/containers/Auth/index.tsx